import  {  useEffect, useState } from "react";
import arrowBack from "../../assets/Images/arrow_back_ios_new.png";
import money_patrol_ui from "../../assets/Images/money_patrol_logo.svg";
import circle_right_arrow from "../../assets/Images/circle_right_arrow.svg";
import back_arrow_money from "../../assets/Images/back_arroe_money.svg";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LoaderComponent from "../../components/LoaderComponent";
import "./MoneyPatrol.css"; // Import your CSS file for animations
import {useAsaSession,useAsaSessionPagesMutation,useIsLoading} from '../../services/AsaSessionServices'
import {useActiveSubscriptions,useSubscriptionsPlans,
  useSubscriptionPurchaseMutation,useFintechLayouts} from '../../services/AsaApiServices'
import { IAsaSession, SessionPage } from "../../types/types";
import {showCustomToast} from '../../services/toastService'
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
const MoneyPatrolLanding2 = () => {
  const { t } = useTranslation();
 
  //to remove , because it's used only for backward comp
  const [isLocalFetch,setIsLocalFetch]=useState(false)
  const {data:session}=useAsaSession()
  const {data:subscriptions}=useActiveSubscriptions()
  const {data:subscriptionsPlans}=useSubscriptionsPlans()
  const sessionMutation= useAsaSessionPagesMutation()
  const layout = useFintechLayouts()
  const subscriptionPurchaseMutation= useSubscriptionPurchaseMutation()
  const navigate = useNavigate();

  const [selectedPlan, setSelectedPlan] = useState<{
    subscriptionTitle: string;
    description: string;
    oneTimeAmount: any;
    plan: any;
    recurringAmount: any;
    subscriptionIcon: string;
    billingCycle: string;
  } | null>(null);
 const [isGlobalLoading]=useIsLoading()

  // Handling Update Session Error
  const isLoading=isGlobalLoading || isLocalFetch

  useEffect(() => {
    AnalyticsService.track("Money Patrol Landing Viewed", AnalyticsAction.View, AnalyticsFeature.MoneyPatrol);
  }, []);

  const onBackButtonClick = () => {
    if (selectedPlan) {
      setSelectedPlan(null);
    } else {
      if (session) {
        const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 0);
        if (targetPage) {
          const pageData = JSON.parse(targetPage.pageData);
          const backActionDynamicLink = pageData.backActionDynamicLink;
          if (backActionDynamicLink) {
            window.location.href = backActionDynamicLink;
          } else {
            console.error(t("backActionNotFound"));
          }
        }
      }
    }
  };

  const onBackPlanSelect = () => {
    setSelectedPlan(null);
  };

  const getPlanCost = (plan: string, oneTimeAmount: any) => {
    switch (plan) {
      case "FREE":
        return ` ${formatAmount(oneTimeAmount)}`; // Incorporate oneTimeAmount
      case "ANNUAL":
        return `${formatAmount(oneTimeAmount)}  ${t("annually")}`; // Add "Annual" text
      case "LIFETIME":
        return `${formatAmount(oneTimeAmount)} ${t("oneTime")}`; // Incorporate oneTimeAmount
      default:
        return "";
    }
  };

  const getRecurringAmount = (plan: string, amount: any) => {
    switch (plan) {
      case "LIFETIME":
        return `+${formatAmount(amount)} ${t("annually")}`;
      default:
        return "";
    }
  };

  // Helper function to format the oneTimeAmount
  const formatAmount = (amount: any) => {
    if (amount != null) {
      return `$${amount}`; // Format the amount with a dollar sign
    }
    return "";
  };

  const isEligibleForTrialPlan = subscriptionsPlans?.some(
    (plan) => plan.isConsumerEligibleForTrial
  );
  const getPlanDetailsText=()=>{
    switch (selectedPlan?.subscriptionTitle) {
      case "FREE":
        return t("accessFeaturesFree");
      case "ANNUAL":
        return t("accessFeaturesAnnual");
      default:
        return t("accessFeaturesDefault");
    }
  }
  const getSubscribeButtonText=()=>{
    if (
      subscriptions?.some(
        (subscription) => subscription.subscriptionPlanCode === selectedPlan?.plan?.subscriptionPlanCode
      )
    ) {
      return t("manageSubscription");
    }
    if (subscriptions?.some(() => true)) {
      return t("upgradeSubscription");
    }
    if (selectedPlan?.plan?.subscriptionTitle === "Lifetime Access") {
      return t("purchaseLifetime");
    }
    return selectedPlan?.plan?.subscriptionTitle === "FREE" ? t("foreverFree") : t("startFreeTrial");
  }
  const handlePlanClick = async (plan: any) => {
    AnalyticsService.track("Money Patrol Plan Clicked", AnalyticsAction.Click, AnalyticsFeature.MoneyPatrol, {
      subscriptionName: plan?.subscriptionTitle,
      price: plan?.recurringAmount,
      billingCycle: plan?.billingCycle,
    });
    setSelectedPlan(plan); // Set the selected plan

    //if(subscriptions?.some((x)=>x.subscriptionPlanCode===plan.plan?.subscriptionPlanCode)){
    //  navigate("/manageSubscriptions");
    //}
  };
  const saveForeverSubscription = async () => {
    
    try {
      const requestData = {
        comment: "Free Plan",
        billingEmail: null,
        isAcceptTerms: true,
        firstName: null,
        middleName: null,
        lastName: null,
        subscriptionPlanCode: selectedPlan?.plan?.subscriptionPlanCode,
        address: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        postalCode: null,
        couponCode: null,
      };
      await subscriptionPurchaseMutation.mutateAsync(requestData)
      AnalyticsService.track("Money Patrol Free Subscription Success", AnalyticsAction.API_Result, AnalyticsFeature.MoneyPatrol, {
        subscriptionName: selectedPlan?.subscriptionTitle,
        price: selectedPlan?.recurringAmount,
      });

    } catch (error) {
      AnalyticsService.track("Money Patrol Free Subscription Error", AnalyticsAction.API_Result, AnalyticsFeature.MoneyPatrol, {
        subscriptionName: selectedPlan?.subscriptionTitle,
        price: selectedPlan?.recurringAmount,
      });
      if (error instanceof Error) {
        showCustomToast(error.message, true);
      } else {
        showCustomToast("Error select subscriptions",true)
      }

    }
  }
  const handleBilling = async () => {
    const isSubscriptionMatched = subscriptions?.some(
      (x) => x.subscriptionPlanCode === selectedPlan?.plan?.subscriptionPlanCode
    );

    if (isSubscriptionMatched) {
      navigate("/manageSubscriptions");
    } else if (selectedPlan?.plan?.isFree) {
      await saveForeverSubscription();

      if (session) {
        let successDynamicLink = null;
        const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 0);
        if (targetPage) {
          const pageData = JSON.parse(targetPage.pageData);
          successDynamicLink = pageData.successDynamicLink;
        }

        if (successDynamicLink) {
          window.location.href = successDynamicLink;
        } else {
          console.error(t("backActionNotFound"));
        }
      } else {
        console.error(t("errorProcessingCheckout"));
      }
    } else {
      try {
        setIsLocalFetch(true);
        const sessionToUpdate: IAsaSession = { ...session } as IAsaSession;
        sessionToUpdate.sessionPages = undefined;
        const sessionpages = [] as SessionPage[];
        const selectPackagepage: SessionPage = {
          pageNumber: 2,
          pageName: "GOALS PLANS",
          pageTitle: "Select Package",
          pageDescription: "Select Package",
          pageUrl: "/moneypatrol",
          pageStatusMessage: "INCOMPLETE",
          pageData: JSON.stringify(selectedPlan?.plan),
        } as SessionPage;
        sessionpages.push(selectPackagepage);

        sessionpages.push({
          pageNumber: 81,
          pageName: "Landingyes",
          pageTitle: "Landingyes",
          pageDescription: "Landingyes",
          pageUrl: "/moneypatrol",
          pageData: JSON.stringify({ Landing: "true" }),
        } as SessionPage);

        const response = await sessionMutation.mutateAsync({
          asaSession: sessionToUpdate,
          extraPages: sessionpages,
        });
        AnalyticsService.track("Money Patrol Proceed Success", AnalyticsAction.API_Result, AnalyticsFeature.MoneyPatrol, {
          subscriptionName: selectedPlan?.plan?.subscriptionTitle,
          price: selectedPlan?.plan?.recurringAmount,
        });
        navigate("/subscriptionpayment");
      } catch (error) {
        AnalyticsService.track("Money Patrol Proceed Error", AnalyticsAction.API_Result, AnalyticsFeature.MoneyPatrol, {
          subscriptionName: selectedPlan?.plan?.subscriptionTitle,
          price: selectedPlan?.plan?.recurringAmount,
        });
        console.error(t("errorProcessingCheckout"), error);
        showCustomToast(t("errorProcessingCheckout"), true);
      } finally {
        setIsLocalFetch(false);
      }
    }
  };

  return (
    <div className="bg-[#121212] flex justify-center items-center min-h-screen">
      {isLoading && <LoaderComponent />}
      <div className="bg-gradient-to-r from-[#05ACEC] to-[#0051C4] w-full h-screen overflow-y-auto text-white relative z-20">
        <div className="flex items-center justify-evenly space-x-8 pt-8 p-3">
          <div className="back-button-container-money">
            <img
              className="back-button"
              src={arrowBack}
              onClick={onBackButtonClick}
              alt={t("back")}
            />
          </div>

          <h1 className="font-poppins ml-3 text-[22px] leading-[28px] tracking-[1px] w-[500px] h-[56px] mt-6">
            {t("choosePlan")}
          </h1>
        </div>

        <img
          src={money_patrol_ui}
          className="relative top-2 left-5 z-50 w-[65px] h-[65px]"
          alt="Flash"
        />

        

        <div className="bg-[#121212] top-8 rounded-more text-gray-800 mx-auto rounded-t-[3rem] absolute bottom-0 left-0 right-0 h-full overflow-y-auto mt-24">
          <div className="h-full p-6 shadow-lg">
            <span className="font-semibold relative -top-4 font-poppins text-[18px] ml-20 text-white">
             {layout?.appName?? t("moneyPatrol")}
            </span>
 {/* start refactor. */}
          {selectedPlan &&
                          <div className="bg-[#0B1727] mt-10 text-white w-full \ rounded-lg shadow-lg border-2 border-[#2F3947] p-6 flex flex-col items-center">
                          <div className="w-full flex justify-between items-center mb-4">
                            <div className="flex items-center">
                              <img
                                src={back_arrow_money}
                                alt="Back"
                                className="cursor-pointer w-[22px] h-[22px] mr-2"
                                onClick={onBackPlanSelect}
                              />
                              <span className="text-[18px] font-poppins">
                                {selectedPlan.subscriptionTitle}
                              </span>
                            </div>
                            <div className="subscription-title-money">
                              {getPlanCost(
                                selectedPlan.subscriptionTitle,
                                selectedPlan?.oneTimeAmount
                              )}
                            </div>
                          </div>

                          <div className="w-full flex justify-between items-center mb-4">
                            <div className="flex items-center">
                              {""}
                            </div>
                            <div className="subscription-title-add-money">
                              {getRecurringAmount(
                                selectedPlan.subscriptionTitle,
                                selectedPlan?.recurringAmount
                              )}
                            </div>
                          </div>
                          
                          <p className="text-[14px] mb-2 leading-[1.4]">
                            {selectedPlan.description}
                          </p>
          
                          <p className="text-[14px] mb-4 mt-4">
                            <span className="mr-2">•</span>
                            {getPlanDetailsText()}
                          </p>
                        </div>
            }
            {!!!selectedPlan &&
              <div className="bg-[#121212] text-white h-screen flex flex-col">
              <div className="flex flex-col mt- items-center justify-center ">
                <p className="px-6 mb-8 mt-8 font-poppins">
                  {t("positiveImpact")}
                </p>

                {/* Find the FREE plan in the plans array */}
                { subscriptionsPlans &&
                  subscriptionsPlans.length > 0 && isEligibleForTrialPlan
                  &&
                  <button className="bg-[#22262c] text-white px-20 py-3 rounded-lg mb-6 font-poppins">
                    {t("freeTrial") }
                  </button>
                }
              </div>

              <div className="flex flex-col items-center space-y-6 mb-8">
                {subscriptionsPlans && subscriptionsPlans
                  .filter((plan) => plan.subscriptionTitle.trim() !== "") // Filter out empty titles
                  .map((plan) => {
                    // Remove everything after "Annual" or "Lifetime" (including spaces)
                    const displayTitle = plan.subscriptionTitle
                      .replace(/(Annual|Lifetime).*$/, "$1")
                      .toUpperCase();

                    return (
                      <button
                        key={plan?.subscriptionPlanId}
                        className="bg-[#0B1727] px-6 py-4 h-[60px] w-full rounded-[15px] flex justify-between items-center border-[2px] border-custom-gray"
                        onClick={() =>
                          handlePlanClick({
                            subscriptionTitle: displayTitle,
                            description: plan.description,
                            oneTimeAmount: plan.oneTimeAmount,
                            plan: plan,
                            recurringAmount: plan.recurringAmount,
                            subscriptionIcon: plan.subscriptionIcon,
                            billingCycle: plan.billingCycle
                          })
                        }
                      >
                        {displayTitle}
                        <img
                          src={circle_right_arrow}
                          alt="Arrow"
                          className="w-6 h-6"
                        />
                      </button>
                    );
                  })}
              </div>
            </div>              
            }

            {selectedPlan && subscriptions && 
              <button
                className="bg-[#006BD2] text-white px-4 py-2 rounded-lg mt-4 fixed bottom-4 left-1/2 transform -translate-x-1/2 max-w-xs w-full font-semibold"
                onClick={() => {
                  AnalyticsService.track("Money Patrol Subscribe Clicked", AnalyticsAction.Click, AnalyticsFeature.MoneyPatrol, {
                    subscriptionName: selectedPlan?.subscriptionTitle,
                    price: selectedPlan?.recurringAmount,
                  });
                  handleBilling();
                }}
              >
                {getSubscribeButtonText()}
              </button>
            }
 {/* end refactor. */}            

          </div>


        </div>
      </div>
    </div>
  );
};

export default MoneyPatrolLanding2;
